import classNames from 'classnames'

import { getQaSelector } from '../../utils/common'

import {
  DEFAULT_MAX_COUNT,
  QA_NAME_COUNTER,
  THEME_VARIANT,
} from './Counter.constants'
import { CounterValue } from './CounterValue'

import * as styles from './Counter.module.css'

function Counter({
  children,
  className,
  count,
  fixed,
  maxCount = DEFAULT_MAX_COUNT,
  qaName,
  variant = THEME_VARIANT,
}) {
  if (!count) {
    return null
  }

  const counterClassName = classNames(
    styles.counter,
    styles[variant],
    className
  )

  const qaProps = getQaSelector({
    context: QA_NAME_COUNTER,
    def: QA_NAME_COUNTER,
    value: qaName,
  })

  return (
    <div {...qaProps} className={counterClassName}>
      <CounterValue count={count} fixed={fixed} maxCount={maxCount} />
      {children}
    </div>
  )
}

export default Counter
